import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';

import { Button } from '../../components/ui/button';
import HeaderEditor from '../../components/CMS/HeaderEditor';
import FooterEditor from '../../components/CMS/FooterEditor';
import BlocksManager from '../../components/CMS/BlocksManager';
import MediaLibrary from '../../components/CMS/MediaLibrary';
import PagesManager from '../../components/CMS/PagesManager';
import { Layout, Image, FileText, Grid, ArrowLeft } from 'lucide-react';

const CMSDashboard = () => {
  const [activeTab, setActiveTab] = useState('media');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate('/admin/super-dashboard')}
            className="mb-4 text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour au tableau de bord Super Admin
          </Button>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            🎨 Gestion de Contenu (CMS)
          </h1>
          <p className="text-gray-600">
            Gérez l'intégralité du contenu du site : Header, Footer, Blocs, Pages et Médias
          </p>
        </div>

        {/* Tabs Navigation */}
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-5 bg-white rounded-lg shadow-sm p-1">
            <TabsTrigger value="media" className="flex items-center gap-2">
              <Image className="h-4 w-4" />
              <span>Médiathèque</span>
            </TabsTrigger>
            <TabsTrigger value="header" className="flex items-center gap-2">
              <Layout className="h-4 w-4" />
              <span>Header</span>
            </TabsTrigger>
            <TabsTrigger value="footer" className="flex items-center gap-2">
              <Layout className="h-4 w-4 rotate-180" />
              <span>Footer</span>
            </TabsTrigger>
            <TabsTrigger value="blocks" className="flex items-center gap-2">
              <Grid className="h-4 w-4" />
              <span>Blocs</span>
            </TabsTrigger>
            <TabsTrigger value="pages" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              <span>Pages</span>
            </TabsTrigger>
          </TabsList>

          {/* Tab Contents */}
          <TabsContent value="media">
            <MediaLibrary />
          </TabsContent>

          <TabsContent value="header">
            <HeaderEditor />
          </TabsContent>

          <TabsContent value="footer">
            <FooterEditor />
          </TabsContent>

          <TabsContent value="blocks">
            <BlocksManager />
          </TabsContent>

          <TabsContent value="pages">
            <PagesManager />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default CMSDashboard;